const localizers = {
  'Alerts.noAlerts.txt': () => `Bu rapor için bir uyarı ayarlanmadı.`,
  'BirdImage.image.txt': () => `Görüntü`,
  'ComboBox.clearFilter.txt': () => `Filtreyi temizle`,
  'ComboBox.defautValueNoData.fmt': ({categoryValue}) => `${categoryValue} (Veri Yok)`,
  'ContextMenu.selectAll.txt': () => `Tümünü seç`,
  'ContextMenu.clearSelection.txt': () => `Seçimi temizle`,
  'ContextMenu.exportImage.txt': () => `Görüntü Olarak Dışa Aktar`,
  'ContextMenu.sortAscending.fmt': ({role}) => `${role}: Artan`,
  'ContextMenu.sortDescending.fmt': ({role}) => `${role}: Azalan`,
  'ContextMenu.sortAddAscending.fmt': ({role}) => `${role}: Artan sırada ekle`,
  'ContextMenu.sortAddDescending.fmt': ({role}) => `${role}: Azalan sırada ekle`,
  'ContextMenu.removeSortItem.fmt': ({role}) => `Sıralamadan ${role} öğesini kaldır`,
  'ContextMenu.removeSortLevel.txt': () => `Sıralama düzeyini kaldır`,
  'ContextMenu.sort.txt': () => `Sırala`,
  'ContextMenu.selectShortestPath.txt': () => `En kısa yolu seç`,
  'ContextMenu.explain.txt': () => `Verileri açıkla`,
  'ContextMenu.explainRole.txt': ({role}) => `Şunu açıkla: ${role}...`,
  'ContextMenu.manageColumns.txt': () => `Sütunları yönet`,
  'ContextMenu.includeMissingValues.txt': () => `Eksik değerleri dahil et`,
  'DrillableTooltip.drill.txt': () => `DÖKÜM`,
  'DrillableTooltip.tooltip.txt': () => `ARAÇ İPUCU`,
  'DrillableTooltip.links.txt': () => `BAĞLANTILAR`,
  'DrillableTooltip.section.link.fmt': ({page}) => `${page} İçin Sayfa Bağlantısı`,
  'DrillableTooltip.report.link.fmt': ({report}) => `${report} Öğesine Rapor Bağlantısı`,
  'DrillableTooltip.external.link.fmt': ({url}) => `${url} Öğesine Harici Bağlantı`,
  'DrillableTooltip.notAvailable.txt': () => `Kullanılamaz`,
  'Breadcrumb.all.fmt': ({label}) => `Tümü: ${label}`,
  'BrowserCheck.title.txt': () => `WebGL Denetimi`,
  'BrowserCheck.msg.txt': () => `WebGL devre dışı veya tarayıcınız tarafından desteklenmiyor.   \nRaporu klasik görüntüleyicide görüntülemek için Tamam’a tıklayın.`,
  'EmailUtil.subject.multiple.txt': () => `Gözden geçirilecek raporlar`,
  'EmailUtil.tooLongEmail.txt': () => `E-posta uzunluk limiti aşıldı. E-postayla gönderilecek daha az rapor seçin.`,
  'HiddenSectionDialog.close.txt': () => `Kapat`,
  'HiddenSectionDialog.export.txt': () => `PDF olarak dışa aktar`,
  'InfoPanel.information.txt': () => `Bilgi`,
  'InfoPanel.comments.txt': () => `Yorumlar`,
  'InfoPanel.alerts.txt': () => `Uyarılar`,
  'IncomingFilters.promptbars.txt': () => `Bilgi İstemi Çubukları`,
  'Information.title.txt': () => `Başlık`,
  'Information.name.txt': () => `Ad:`,
  'Information.description.txt': () => `Açıklama:`,
  'Information.displayRules.txt': () => `Görüntüleme kuralları:`,
  'Information.graphLevel.txt': () => `Grafik Düzeyi`,
  'Information.reportLevel.txt': () => `Rapor Düzeyi`,
  'Information.legend.txt': () => `Gösterge`,
  'Information.incomingFilters.txt': () => `Gelen filtreleri:`,
  'Information.noIncomingFilters.txt': () => `Gelen Filtreleri yok`,
  'Information.dataSourceFilters.txt': () => `Veri kaynağı filtreleri:`,
  'Information.interactiveFilters.txt': () => `Etkileşimli filtreler:`,
  'MobileContainer.mobileBIMessage.txt': () => `Mobil cihazınızda SAS raporlarına erişin.`,
  'ObjectTypes.report.txt': () => `Rapor`,
  'ObjectTypes.Report.BI.txt': () => `SAS raporu (2G)`,
  'ObjectTypes.Report.StoredProcess.txt': () => `Stored process report`,
  'ObjectTypes.StoredProcess.txt': () => `Depolanan işlem`,
  'MissingValues.label.txt': () => `(eksik değerler)`,
  'PromptContainer.apply.txt': () => `TAMAM`,
  'PromptContainer.cancel.txt': () => `İptal`,
  'PromptContainer.close.txt': () => `Kapat`,
  'TextFieldTypeAhead.validation.range.fmt': ({min, max}) => `Değer, ${min} ile ${max} arasında (dahil) bir sayı olmalıdır.`,
  'TextFieldTypeAhead.validation.numeric.txt': () => `Geçerli bir sayısal değer belirtin.`,
  'TextFieldTypeAhead.validation.string.txt': () => `Değer, atanmış veri için geçerli değil.`,
  'TextFieldTypeAhead.categoryAndMeasureTooltip.fmt': ({categoryLabel, measureLabel}) => `Girin: ${categoryLabel}, ${measureLabel}`,
  'TextFieldTypeAhead.categoryTooltip.fmt': ({categoryLabel}) => `Girin: ${categoryLabel}`,
  'TextFieldTypeAhead.placeholder.fmt': ({placeholderLabel}) => `Girin: ${placeholderLabel}...`,
  'RangeSlider.tooltip.fmt': ({label, min, max}) => `${label}: ${min} - ${max}`,
  'Slider.missingValues.txt': () => `Eksik değerler`,
  'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt': ({categoryLabel, categoryValue, measureLabel, measureValue}) => `${categoryLabel}: ${categoryValue}, ${measureLabel}: ${measureValue}`,
  'PromptElement.categoryLabelValueTooltip.fmt': ({categoryLabel, categoryValue}) => `${categoryLabel}: ${categoryValue}`,
  'ReportContainer.back.txt': () => `Geri`,
  'ReportContainer.reportCorrupted.txt': () => `RAPOR BOZUK`,
  'ReportContainer.themeLoadFailed.txt': () => `Rapor teması yüklenemedi.`,
  'ReportContainer.restoreButton.tip.txt': () => `Raporu geri yükle`,
  'ReportContainer.restoreButtonAriaAnnounce.txt': () => `Rapor geri yüklendi`,
  'ReportContainer.renderError.txt': () => `Bir hata oluştu. Raporu gösterilemedi.`,
  'ReportContainer.component.renderError.txt': () => `Bir hata oluştu. Bileşen oluşturulamadı.`,
  'ReportContentPage.open.txt': () => `Aç...`,
  'ReportContentPage.refreshReport.txt': () => `Raporu yenile`,
  'ReportContentPage.editReport.txt': () => `Raporu düzenle`,
  'ReportContentPage.print.txt': () => `Yazdır...`,
  'ReportContentPage.email.txt': () => `E-posta...`,
  'ReportContentPage.export.txt': () => `Excel’e Dışa Aktar...`,
  'ReportContentPage.reportProperties.txt': () => `Rapor Özellikleri`,
  'ReportContentPage.shareReport.txt': () => `Raporu paylaş`,
  'ReportContentPage.enableOverlays.txt': () => `Nesne yer paylaşımlarını etkinleştir`,
  'ReportContentPage.disableOverlays.txt': () => `Nesne yer paylaşımlarını devre dışı bırak`,
  'ReportContentPage.link.txt': () => `Bağlantı...`,
  'ReportContentPage.settings.txt': () => `Ayarlar...`,
  'ReportContentPage.editPlayback.txt': () => `Kayıttan yürütmeyi düzenle`,
  'ReportContentPage.playReport.txt': () => `Raporu oynat`,
  'ReportContentPage.showFiltersButton.tip.txt': () => `Belirtilen filtreleri göster`,
  'ReportContentPage.hideFiltersButton.tip.txt': () => `İstenen filtreleri gizle`,
  'ReportContentPage.reportFilters.txt': () => `Rapor düzeyi`,
  'ReportContentPage.pageFilters.txt': () => `Sayfa düzeyi`,
  'ReportContentPage.refreshRequired.txt': () => `Rapor yenilemesi gerekiyor`,
  'ReportContentPage.infoButton.tip.txt': () => `Bilgi Paneli`,
  'ReportContentPage.backButton.tip.txt': () => `Tüm raporları görüntüle`,
  'ReportContentPage.overflowMenuButton.tip.txt': () => `Diğer seçenekler`,
  'ReportContentPage.itemGroupName.txt': () => `Raporlar`,
  'ReportContentPage.maximizeButton.tip.txt': () => `Raporla ekranı kapla`,
  'ReportContentPage.closeButton.txt': () => `Raporu kapat`,
  'ReportContentPage.maximizeButtonAriaAnnounce.txt': () => `Raporla ekran kaplandı`,
  'ReportContentPage.resetReportState.txt': () => `Varsayılan rapor durumunu geri yükle`,
  'ReportContentPage.summary.txt': () => `Özeti göster`,
  'ReportManagerPage.objectMenu.open.txt': () => `Aç`,
  'ReportManagerPage.objectMenu.edit.txt': () => `Düzenle`,
  'ReportManagerPage.objectMenu.summary.txt': () => `Özet`,
  'ReportManagerPage.objectMenu.properties.txt': () => `Özellikler`,
  'ReportManagerPage.objectMenu.email.txt': () => `E-posta...`,
  'ReportManagerPage.objectMenu.print.txt': () => `Yazdır`,
  'ReportManagerPage.browseReportsButton.txt': () => `Raporlara Gözat`,
  'ReportManagerPage.newReportButton.txt': () => `Yeni Rapor`,
  'ReportManagerPage.emptyView.message.txt': () => `Rapor bulunamadı.`,
  'ReportManagerPage.emptyView.browseReportsButton.txt': () => `Raporlara Gözat`,
  'ReportManagerPage.tableView.name.txt': () => `Ad`,
  'ReportManagerPage.tableView.author.txt': () => `Yazar`,
  'ReportManagerPage.tableView.lastModified.txt': () => `Son Değiştirme Zamanı`,
  'ReportManagerPage.openButton.tip.txt': () => `Raporu aç`,
  'ReportManagerPage.emailButton.tip.txt': () => `Raporu E-postayla Gönder`,
  'ReportManagerPage.printButton.tip.txt': () => `Raporu PDF’ye yazdır`,
  'ReportManagerPage.propertiesButton.tip.txt': () => `Rapor özellikleri`,
  'ReportObject.multipleReferences.error.txt': () => `Rapor nesneleri birden fazla bağlamda kullanılamaz.`,
  'ReportObject.notFound.error.txt': () => `Nesne adı belirtilen raporda bulunamadı.`,
  'ReportObject.invalidPage.error.txt': () => `The belirtilmiş sayfa geçersiz.`,
  'ReportPropertiesDialog.open.txt': () => `Aç`,
  'ReportPropertiesDialog.close.txt': () => `Kapat`,
  'ReportPropertiesDialog.name.txt': () => `Ad:`,
  'ReportPropertiesDialog.description.txt': () => `Açıklama:`,
  'ReportPropertiesDialog.keywords.txt': () => `Anahtar sözcükler:`,
  'ReportPropertiesDialog.type.txt': () => `Tür:`,
  'ReportPropertiesDialog.location.txt': () => `Konum:`,
  'ReportPropertiesDialog.createdBy.txt': () => `Oluşturan:`,
  'ReportPropertiesDialog.dateCreated.txt': () => `Oluşturma tarihi:`,
  'ReportPropertiesDialog.modifiedBy.txt': () => `Değiştiren:`,
  'ReportPropertiesDialog.dateModified.txt': () => `Düzenleme tarihi:`,
  'ReportSections.newPageButton.txt': () => `Yeni sayfa`,
  'ReportSections.closeTab.tooltip.txt': () => `Sayfayı sil`,
  'ReportSections.menuButton.tooltip.fmt': ({label}) => `${label} menüsü`,
  'ReportSummaryDialog.title.txt': () => `Özet`,
  'ReportSummaryDialog.open.txt': () => `Aç`,
  'ReportSummaryDialog.cancel.txt': () => `İptal`,
  'ReportSummaryDialog.close.txt': () => `Kapat`,
  'ReportSummaryDialog.noSummary.txt': () => `Özet yok.`,
  'ReportTileBody.modifiedBy.txt': () => `Değiştiren:`,
  'ReportTileBody.lastModified.txt': () => `Son değiştirme zamanı:`,
  'VAViewerSettingsProvider.reportViewer.txt': () => `SAS Rapor Görüntüleyici`,
  'VAViewerSettingsProvider.reportRefreshSettings.txt': () => `Rapor Yenileme`,
  'VAViewerSettingsProvider.reportAutoRefresh.txt': () => `Raporu Otomatik Yenileme`,
  'VAViewerSettingsProvider.reportRefreshFrequency.txt': () => `Şu kadar dakika sonra güncellemeleri denetle:`,
  'VAViewerSettingsProvider.alert.group.label.txt': () => `Uyarı Bildirimleri`,
  'VAViewerSettingsProvider.alert.field.label.txt': () => `Varsayılan uyarı bildirimlerini seçin:`,
  'VAViewerSettingsProvider.alert.email.txt': () => `E-posta iletileri gönder`,
  'VAViewerSettingsProvider.alert.sms.txt': () => `SMS metin iletileri gönder`,
  'VAViewerSettingsProvider.alert.system.txt': () => `Yönetici varsayılanı`,
  'VAViewerSettingsProvider.generalSettings.txt': () => `Temalar`,
  'VAViewerSettingsProvider.enableHighContrast.txt': () => `Rapor temasını geçersiz kıl ve SAS Yüksek Kontrast rapor temasını kullan`,
  'ViewerBusyDialog.openReport.txt': () => `Rapor açılıyor...`,
  'ViewerBusyDialog.prepareExport.txt': () => `Dışa aktarma hazırlanıyor...`,
  'ViewerBusyDialog.preparePrint.txt': () => `Yazdırmaya hazırlanıyor...`,
  'PDFGeneration.printingReport.txt': () => `PDF rapor oluşturuluyor. Hazır olunca indirilecek.`,
  'PDFGeneration.fileName.fmt': ({date, fileName}) => `${date} tarihinde ${fileName}`,
  'VisualElementActionUtil.actionMenuLabel.txt': () => `Bir eylem seçin`,
  'VisualElementActionUtil.hierarchyExhausted.txt': () => `En düşük hiyerarşi düzeyine ulaştınız.`,
  'VisualElementActionUtil.hierarchiesExhausted.txt': () => `Tüm hiyerarşilerin en alt düzeyine ulaştınız.`,
  'VisualElementActionUtil.drillLabel.fmt': ({value}) => `${value} Öğesinin ayrıntısına in`,
  'SaveImageUtil.snapshot.fmt': ({a0, a1, a2}) => `${a0} İçin Anlık görünüm ${a1} ${a2}`,
  'ObjectToolbarIcon.SaveImageTooltip.txt': () => `Görüntüyü kaydet`,
  'ObjectToolbarIcon.PrintObject.txt': () => `Nesneyi yazdır...`,
  'ObjectToolbarIcon.ShareObject.txt': () => `Nesneyi paylaş...`,
  'ObjectToolbarIcon.OverflowButton.default.txt': () => `Daha fazla`,
  'ObjectToolbarIcon.OverflowButton.labeled.fmt': ({label}) => `${label} İçin nesne menüsü`,
  'ObjectToolbarIcon.Accelerator.txt': () => `SAS® Graphics Accelerator ile görüntüle`,
  'ZoomControl.button.tip.txt': () => `Yakınlaştır`,
  'ZoomControl.button.zoomin.txt': () => `Yakınlaştır`,
  'ZoomControl.button.zoomout.txt': () => `Uzaklaştır`,
  'ZoomControl.button.display.txt': () => `Yakınlaştırma Denetimleri`,
  'ZoomControl.button.reset.txt': () => `Yakınlaştırmayı sıfırla`,
  'ExpandControl.button.expand.txt': () => `Görünümü büyüt`,
  'ExpandControl.button.restore.txt': () => `Görünümü geri yükle`,
  'ExpandControl.button.expand.tip.txt': () => `Ekranı kapla`,
  'ExpandControl.button.restore.tip.txt': () => `Geri yükle`,
  'ReportVisualContainer.sectionLink.notAllowed.maximize.txt': () => `Bu nesne ekranı kaplarken sayfa bağlantıları yürütülemez.`,
  'DragModeControl.button.pan.tip.txt': () => `Yatay Kaydır`,
  'DragModeControl.button.circular.tip.txt': () => `Dairesel seçim`,
  'DragModeControl.button.freeform.tip.txt': () => `Serbest biçimli seçim`,
  'DragModeControl.button.rectangular.tip.txt': () => `Dikdörtgen seçim`,
  'DragModeControl.button.zoom.tip.txt': () => `Dikdörtgene yakınlaştır`,
  'ReportXMLDialog.title.txt': () => `Rapor XML’i`,
  'ReportXMLDialog.closeButton.txt': () => `Kapat`,
  'ReportXMLDialog.copyButton.txt': () => `Panoya Kopyala`,
  'ReportXMLDialog.error.txt': () => `Rapor XML’i yüklenirken hata oluştu`,
  'ErrorDialog.error.txt': () => `Bir hata oluştu. Lütfen sistem yöneticinizle görüşün.`,
  'Application.banner.txt': () => `SAS® Rapor Görüntüleyici`,
  'Application.wip.banner.txt': () => `SAS® Visual Analytics - Rapor Görüntüleyici`,
  'Application.productName.txt': () => `SAS® Visual Analytics`,
  'OpenReportDialog.title.txt': () => `Raporu Aç`,
  'OpenReportDialog.reports.txt': () => `Raporlar:`,
  'OpenReportDialog.cancel.txt': () => `İptal`,
  'OpenReportDialog.ok.txt': () => `TAMAM`,
  'AriaLive.numberOfObjectsUpdated.fmt': ({count}) => `${count} nesne güncellendi`,
  'AriaLive.oneObjectUpdated.txt': () => `1 nesne güncellendi`,
  'AriaLive.reportOpened.txt': () => `Rapor açıldı`,
  'AriaLive.reportClosed.txt': () => `Rapor kapatıldı`,
  'ExportData.generating.txt': () => `Dışa aktarma oluşturuluyor. Hazır olunca indirilecek.`,
  'ExportData.warning.txt': () => `Veriler oluşturulurken hata oluştu`,
  'ExportData.nodata.txt': () => `Dışa aktarılacak veri yok`,
  'ExportData.exportData.txt': () => `Verileri dışa aktar...`,
  'PlaybackAnimationDialog.saveButton.txt': () => `Kaydet`,
  'PlaybackAnimationDialog.cancelButton.txt': () => `İptal`,
  'PlaybackAnimationDialog.playButton.txt': () => `Raporu oynat`,
  'PlaybackAnimationDialog.title.txt': () => `Kayıttan Yürütmeyi Düzenle`,
  'PlaybackAnimationDialog.transitionUnit.label.txt': () => `Geçiş birimi:`,
  'PlaybackAnimationDialog.transitionUnit.page.txt': () => `Sayfa`,
  'PlaybackAnimationDialog.transitionUnit.object.txt': () => `Nesne`,
  'PlaybackAnimationDialog.secondsPerUnit.label.txt': () => `Birim başına saniye:`,
  'PlaybackAnimationDialog.showMaximized.label.txt': () => `Ekranı kaplayan nesneleri göster:`,
  'PlaybackAnimationDialog.showCanvasOnly.label.txt': () => `Yalnızca tuvali göster:`,
  'PlaybackAnimationDialog.showTimer.label.txt': () => `Zamanlayıcıyı göster:`,
  'PlaybackAnimationDialog.showNavigationControls.label.txt': () => `Tıklama veya dokunmanın ardından gezinti kontrollerini göster:`,
  'PlaybackNavigationControls.previousPage.txt': () => `Önceki sayfa`,
  'PlaybackNavigationControls.nextPage.txt': () => `Sonraki sayfa`,
  'PlaybackNavigationControls.previousObject.txt': () => `Önceki nesne`,
  'PlaybackNavigationControls.nextObject.txt': () => `Sonraki nesne`,
  'TransportConnection.generateReportTimeout.txt': () => `Raporun yüklenmesi uzun sürüyor. Devam etmek istiyor musunuz?`,
  'TransportConnection.openReport.txt': () => `Raporu Aç`,
  'ViewerContainer.reportNotFound.fmt': ({location}) => `Aşağıdaki konumda belirtilen rapor bulunmuyor: ${location}`,
  'Hierarchy.expand.fmt': ({label}) => `${label} öğesini genişlet`,
  'Hierarchy.collapse.fmt': ({label}) => `${label} öğesini daralt`,
  'GraphElementDecorator.overview.txt': () => `Genel Bakış`,
  'GraphElementDecorator.layers.txt': () => `Katmanları gizle veya göster`,
  'CompositeGraphElementDecorator.hideOverview.txt': () => `Genel Bakışı Gizle`,
  'CompositeGraphElementDecorator.showOverview.txt': () => `Genel Bakışı Göster`,
  'TitleInfoButton.tooltip.txt': () => `Bilgi`,
  'SectionSelectionBar.noSelections.txt': () => `Seçim bulunmuyor`,
  'SectionSelectionBar.title.txt': () => `Filtreler:`,
  'CheckboxList.selectAll.txt': () => `Tümünü seç`,
  'CheckboxList.clearSelection.txt': () => `Seçimi temizle`,
  'CheckboxList.clearSelection.fmt': ({count}) => `Seçimi temizle (${count})`,
  'ExplanationInfoDialog.title.fmt': ({label}) => `Açıklanan: ${label}`,
  'ExplanationInfoDialog.loading.txt': () => `Açıklama hazırlanıyor...`,
  'ExplanationInfoDialog.cancel.txt': () => `İptal`,
  'ExplanationInfoDialog.close.txt': () => `Kapat`,
  'PromptHeader.emptyReport.txt': () => `Rapor bilgi isteği oluşturmak için bir veri öğesini veya denetimi buraya sürükleyin.`,
  'PromptHeader.emptyPage.txt': () => `Sayfa bilgi isteği oluşturmak için bir veri öğesini veya denetimi buraya sürükleyin.`,
  'PromptHeader.collapsePageControlArea.txt': () => `Sayfa denetim alanını daralt`,
  'PromptHeader.expandPageControlArea.txt': () => `Sayfa denetim alanını genişlet`,
  'PromptHeader.collapseReportControlArea.txt': () => `Rapor denetim alanını daralt`,
  'PromptHeader.expandReportControlArea.txt': () => `Rapor denetim alanını genişlet`,
  'PromptHeader.collapseControlArea.txt': () => `Denetim alanını daralt`,
  'PromptHeader.expandControlArea.txt': () => `Denetim alanını genişlet`,
  'PromptHeader.reportControlArea.txt': () => `Rapor denetim alanı`,
  'PromptHeader.allControlAreas.txt': () => `Tüm denetim alanları`,
  'PromptHeader.pageControlArea.txt': () => `Sayfa denetim alanı`,
  'ZeroState.editMode.txt': () => `Bir şablonu, veri öğelerini veya nesneleri buraya sürükleyin.`,
  'ZeroState.viewMode.txt': () => `Görüntülenecek içerik yok.`,
  'ObjectStatus.assignData.txt': () => `Veri Ata`,
  'ObjectStatus.selectImage.txt': () => `Görüntü Seç`,
  'ObjectStatus.selectJob.txt': () => `İş seçin`,
  'ObjectStatus.cancelLoading.txt': () => `Yüklemeyi iptal et`,
  'ObjectStatus.loadingCanceled.txt': () => `Yükleme iptal edildi`,
  'ObjectStatus.resumeLoading.txt': () => `Yüklemeye devam et`,
  'ObjectStatus.refresh.txt': () => `Yenile`,
  'ObjectStatus.setJobParameters.txt': () => `Parametre değerlerini ayarla`,
  'ObjectSearch.title.txt': () => `Coğrafi arama`,
  'ObjectSearch.pin.txt': () => `Sabitle`,
  'ObjectSearch.unpin.txt': () => `Sabitlemeyi çöz`,
  'MainSearchPanel.searchHints.txt': () => `İpucu Ara`,
  'MainSearchPanel.searchResults.txt': () => `Arama Sonuçları`,
  'MainSearchPanel.features.txt': () => `Özellikler`,
  'MainSearchPanel.pin.txt': () => `Yeni sabitleme`,
  'MainSearchPanel.pin.tooltip.txt': () => `Yeni sabitleme`,
  'MainSearchPanel.route.txt': () => `Yeni rota`,
  'MainSearchPanel.route.tooltip.txt': () => `Yeni rota`,
  'MainSearchPanel.geographicArea.txt': () => `Yeni coğrafi alan`,
  'MainSearchPanel.geographicArea.tooltip.txt': () => `Yeni coğrafi alan`,
  'MainSearchPanel.newMyLocationPin.txt': () => `Konumum pini`,
  'MainSearchPanel.myLocationPin.txt': () => `Konumum`,
  'MainSearchPanel.show.txt': () => `Göster`,
  'MainSearchPanel.show.all.txt': () => `Tümünü göster`,
  'MainSearchPanel.hide.txt': () => `Gizle`,
  'MainSearchPanel.hide.all.txt': () => `Tümünü gizle`,
  'MainSearchPanel.delete.txt': () => `Sil`,
  'MainSearchPanel.delete.all.txt': () => `Tümünü sil`,
  'MainSearchPanel.convert.txt': () => `Arama sonuçlarını pinlere dönüştür`,
  'MainSearchPanel.convert.all.txt': () => `Tüm arama sonuçlarını pinlere dönüştür`,
  'MainSearchPanel.showPinLabels.txt': () => `Pin etiketlerini göster`,
  'MainSearchPanel.close.label.txt': () => `Coğrafi arama`,
  'MainSearchPanel.navigate.tooltip.txt': () => `Ayrıntıları göster`,
  'MainSearchPanel.demographics.tooltip.txt': () => `Demografik bilgiler`,
  'PanelHeader.back.tooltip.txt': () => `Geri`,
  'GeographicAreaPanel.title.txt': () => `Coğrafi Alan`,
  'GeographicAreaPanel.draw.txt': () => `Alan çizgi`,
  'GeographicAreaPanel.update.txt': () => `Alanı güncelle`,
  'GeographicAreaPanel.label.txt': () => `Etiket:`,
  'GeographicAreaPanel.location.txt': () => `Konum:`,
  'GeographicAreaPanel.distance.miles.txt': () => `Mesafe (mi):`,
  'GeographicAreaPanel.distance.kilometer.txt': () => `Mesafe (km):`,
  'GeographicAreaPanel.distance.add.txt': () => `Mesafe ekle`,
  'GeographicAreaPanel.time.add.txt': () => `Zaman ekle`,
  'GeographicAreaPanel.distance.delete.txt': () => `Mesafe sil`,
  'GeographicAreaPanel.time.minutes.txt': () => `Zaman (dk):`,
  'GeographicAreaPanel.duration.txt': () => `Süre:`,
  'GeographicAreaPanel.distanceUnits.miles.txt': () => `Mil`,
  'GeographicAreaPanel.distanceUnits.kilometers.txt': () => `Kilometre`,
  'GeographicAreaPanel.menu.clear.txt': () => `Coğrafi alanı temizle`,
  'GeographicAreaPanel.menu.link.txt': () => `Adresi varsayılan olarak veri öğelerine ve pinlere bağla`,
  'GeographicAreaPanel.menu.unlink.txt': () => `Coğrafi alan adresinin bağını kaldır`,
  'GeographicAreaPanel.menu.delete.txt': () => `Coğrafi alanı sil`,
  'GeographicAreaPanel.demographics.txt': () => `Demografik bilgiler`,
  'GeographicAreaPanel.demographics.set.txt': () => `Demografik bilgileri göster`,
  'GeographicAreaPanel.demographics.menu.expand.txt': () => `Görünümü genişlet`,
  'GeographicAreaPanel.demographics.menu.edit.txt': () => `Demografik bilgileri düzenle`,
  'GeographicAreaPanel.demographics.menu.delete.txt': () => `Demografik bilgileri sil`,
  'GeographicAreaPanel.demographics.expired.txt': () => `Demografik bilgilerin yeniden yüklenmesi gerekiyor`,
  'GeographicAreaPanel.demographics.reload.txt': () => `Demografik bilgileri yeniden yükle`,
  'GeographicAreaPanel.invalid.location.txt': () => `Coğrafi alan geçerli bir konuma sahip değil ve oluşturulamıyor.`,
  'TravelTypeField.dateselector.tooltip.txt': () => `Gün ve saat belirleyin`,
  'TravelTypeField.cancel.txt': () => `İptal`,
  'TravelTypeField.ok.txt': () => `Tamam`,
  'TravelTypeField.button.tooltip.txt': () => `Gün ve saat belirleyin`,
  'TravelTypeField.day.txt': () => `Gün:`,
  'TravelTypeField.time.txt': () => `Zaman:`,
  'TravelTypeField.distanceTypes.direct.txt': () => `Doğrudan`,
  'TravelTypeField.distanceTypes.distance.txt': () => `Mesafe`,
  'TravelTypeField.travelType.txt': () => `Seyahat türü:`,
  'TravelTypeField.traffic.txt': () => `Trafiği dahil et:`,
  'TravelTypeField.traffic.offset.txt': () => `Trafik zamanı farkı:`,
  'TravelTypeField.traffic.daytime.txt': () => `Trafik günü ve saati:`,
  'TravelTypeField.distanceTypes.distance.unit.txt': () => `Mesafe birimi`,
  'TravelTypeField.distanceTypes.driving.distance.txt': () => `Sürüş mesafesi`,
  'TravelTypeField.distanceTypes.driving.time.txt': () => `Sürüş zamanı`,
  'TravelTypeField.distanceTypes.trucking.distance.txt': () => `Kamyonla mesafe`,
  'TravelTypeField.distanceTypes.trucking.time.txt': () => `Kamyonla süre`,
  'TravelTypeField.distanceTypes.walking.distance.txt': () => `Yürüyüş mesafesi`,
  'TravelTypeField.distanceTypes.walking.time.txt': () => `Yürüyüş süresi`,
  'TravelTypeField.driveTimeTrafficTypes.none.txt': () => `Hayır`,
  'TravelTypeField.driveTimeTrafficTypes.live.txt': () => `Mevcut trafik`,
  'TravelTypeField.driveTimeTrafficTypes.historic.txt': () => `Tipik trafik`,
  'TravelTypeField.driveTimeTraffic.offset.fmt': ({hour}) => `${hour} sa`,
  'TravelTypeField.driveTimeTraffic.update.refresh.txt': () => `Bu özellik için trafiği güncelle`,
  'TravelTypeField.driveTimeTraffic.update.refreshAll.txt': () => `Tüm özellikler için trafiği güncelle`,
  'TravelTypeField.driveTimeTraffic.update.tooltip.txt': () => `Trafik verilerini güncelle`,
  'RoutePanel.title.txt': () => `Rota`,
  'RoutePanel.draw.txt': () => `Rota çiz`,
  'RoutePanel.update.txt': () => `Rotayı güncelle`,
  'RoutePanel.label.txt': () => `Etiket:`,
  'RoutePanel.locations.txt': () => `Konumlar`,
  'RoutePanel.menu.clear.txt': () => `Rotayı temizle`,
  'RoutePanel.menu.reverse.txt': () => `Rotayı ters çevir`,
  'RoutePanel.menu.add.waypoint.txt': () => `Rota konumu ekle`,
  'RoutePanel.menu.delete.waypoint.txt': () => `Rota konumunu sil`,
  'RoutePanel.menu.unlink.txt': () => `Rota konumunun bağını kaldır`,
  'RoutePanel.menu.arrows.txt': () => `Rota okları`,
  'RoutePanel.menu.arrows.hide.txt': () => `Rota oklarını gizle`,
  'RoutePanel.menu.arrows.show.txt': () => `Rota oklarını göster`,
  'RoutePanel.menu.arrows.oneway.txt': () => `Tek yön`,
  'RoutePanel.menu.arrows.twoway.txt': () => `İki yön`,
  'RoutePanel.menu.delete.txt': () => `Rotayı sil`,
  'RoutePanel.route.width.txt': () => `Rota genişliği`,
  'RoutePanel.distance.txt': () => `Mesafe:`,
  'RoutePanel.distance.miles.fmt': ({distance}) => `${distance} mil`,
  'RoutePanel.distance.kilometers.fmt': ({distance}) => `${distance} km`,
  'RoutePanel.location.add.txt': () => `Konum ekle`,
  'RoutePanel.location.delete.txt': () => `Konumu sil`,
  'RoutePanel.duration.txt': () => `Zaman:`,
  'RoutePanel.invalid.location.txt': () => `Rota geçerli konum bulunmadığı için oluşturulamadı.`,
  'RoutePanel.accessibilityCellInfo.fmt': ({index, location}) => `Konum ${index}, ${location}, girdi`,
  'PinPanel.pinTitle.txt': () => `Pin`,
  'PinPanel.addDescription.txt': () => `Açıklama ekle`,
  'PinPanel.deleteDescription.txt': () => `Açıklamayı sil`,
  'PinPanel.newPin.txt': () => `Bu konumda yeni pin`,
  'PinPanel.deletePin.txt': () => `Pini sil`,
  'PinPanel.linkPins.txt': () => `Pinleri varsayılan olarak veri öğelerine bağla`,
  'PinPanel.unlinkAllItems.txt': () => `Tüm öğelerin bağını kaldır`,
  'PinPanel.unlinkItems.txt': () => `Öğelerin bağını kaldır`,
  'PinPanel.label.txt': () => `Etiket:`,
  'PinPanel.location.txt': () => `Konum:`,
  'PinPanel.description.txt': () => `Açıklama:`,
  'PinPanel.linked.txt': () => `BAĞLANTILI`,
  'PinPanel.searchClickPlaceholder.txt': () => `Ara veya haritada seç`,
  'PinPanel.searchPlaceholder.txt': () => `Ara`,
  'PinPanel.addRoute.txt': () => `Rota ekle`,
  'PinPanel.addRoute.tooltip.txt': () => `Rota ekle`,
  'PinPanel.addArea.txt': () => `Coğrafi alan ekle`,
  'PinPanel.addArea.tooltip.txt': () => `Coğrafi alan ekle`,
  'PinPanel.addArea.title.txt': () => `Coğrafi Alan Ekle`,
  'PinPanel.myLocationTitle.txt': () => `Konumum Pini`,
  'PinPanel.deleteMyLocationPin.txt': () => `Konumum pinini sil`,
  'PinPanel.enableAutoUpdate.txt': () => `Konumum otomatik güncellemesini etkinleştir`,
  'PinPanel.disableAutoUpdate.txt': () => `Konumum otomatik güncellemesini devre dışı bırak`,
  'PinPanel.editAutoRefreshInterval.txt': () => `Konumum otomatik yenileme aralığını düzenle...`,
  'PinPanel.linkToPin.txt': () => `Pine bağla`,
  'PinPanel.useCurrentLocation.txt': () => `Pinin geçerli konumunu kullan`,
  'PinPanel.notDrawn.txt': () => `Çizilmedi`,
  'PinPanel.undetermined.txt': () => `Belirlenmedi`,
  'PinPanel.findMyLocation.txt': () => `Konumumu Bul`,
  'PinPanel.cannotDetermineLocation.txt': () => `Uygulama mevcut konumunuzu belirleyemiyor. Konumunuzu paylaşmak istiyorsanız, tarayıcınız veya aygıtınızda yardıma bakın.`,
  'PinPanel.autoRefreshInterval.txt': () => `Konumum Otomatik Yenileme Aralığı`,
  'PinPanel.interval.hours.txt': () => `Saat:`,
  'PinPanel.interval.minutes.txt': () => `Dakika:`,
  'PinPanel.interval.seconds.txt': () => `Saniye:`,
  'PinPanel.invalid.location.txt': () => `Sabitleme geçerli bir konuma sahip değil ve oluşturulamıyor.`,
  'PinPanel.description.miles.1.fmt': ({value1}) => `${value1} mil`,
  'PinPanel.description.miles.2.fmt': ({value1, value2}) => `${value1}; ${value2} mil`,
  'PinPanel.description.miles.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} mil`,
  'PinPanel.description.kilometers.1.fmt': ({value1}) => `${value1} km`,
  'PinPanel.description.kilometers.2.fmt': ({value1, value2}) => `${value1}; ${value2} km`,
  'PinPanel.description.kilometers.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} km`,
  'PinPanel.description.minutes.1.fmt': ({value1}) => `${value1} dk`,
  'PinPanel.description.minutes.2.fmt': ({value1, value2}) => `${value1}; ${value2} dk`,
  'PinPanel.description.minutes.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} dk`,
  'PinPanel.clearLocation.tooltip.txt': () => `Konum metnini temizle`,
  'DiscardChangesDialog.title.area.txt': () => `Coğrafi Alan`,
  'DiscardChangesDialog.title.route.txt': () => `Rota`,
  'DiscardChangesDialog.text.area.txt': ({label}) => `Coğrafi alanda değişiklikler yaptınız ancak alanı yeniden çizmediniz.\n\n${label} için değişikliklerinizi iptal etmek istiyor musunuz?`,
  'DiscardChangesDialog.text.route.txt': ({label}) => `Rotada değişiklikler yaptınız ancak rotayı yeniden çizmediniz.\n\n${label} için değişikliklerinizi iptal etmek istiyor musunuz?`,
  'DiscardChangesDialog.discard.txt': () => `İptal Et`,
  'DiscardChangesDialog.cancel.txt': () => `İptal`,
  'FeatureErrorDialog.title.area.txt': () => `Coğrafi Alan Çiz`,
  'FeatureErrorDialog.title.route.txt': () => `Rota Çiz`,
  'FeatureErrorDialog.text.area.txt': () => `Coğrafi alan çizilemiyor...\n\nİpucu: Alanınızın konumu yollar gibi seyahat altyapısı içermiyorsa bir coğrafi alan hesaplama mümkün olmayabilir. Bunun yerine mesafe seyahat türünü kullanın veya alanı, seyahat altyapısı olan bir konuma taşıyın.`,
  'FeatureErrorDialog.text.route.txt': () => `Rota çizilemiyor...\n\nİpucu: Rotanızın konumu yollar gibi seyahat altyapısı içermiyorsa bir coğrafi alan hesaplama mümkün olmayabilir. Bunun yerine mesafe seyahat türünü kullanın veya rotayı, seyahat altyapısı olan bir konuma taşıyın.`,
  'FeatureErrorDialog.close.txt': () => `Kapat`,
  'DemographicsSelectorDialog.title.txt': () => `Demografik Bilgileri Göster`,
  'DemographicsSelectorDialog.cancel.txt': () => `İptal`,
  'DemographicsSelectorDialog.ok.txt': () => `Tamam`,
  'DemographicsSelectorDialog.country.txt': () => `Ülke/Bölge`,
  'DemographicsSelectorDialog.tab.basic.txt': () => `Temel`,
  'DemographicsSelectorDialog.tab.advanced.txt': () => `Gelişmiş`,
  'DemographicsSelectorDialog.tab.recent.txt': () => `Son`,
  'DemographicsSelectorDialog.categories.txt': () => `Kategoriler`,
  'DemographicsSelectorDialog.category.income.txt': () => `Gelir`,
  'DemographicsSelectorDialog.category.age.txt': () => `Yaş`,
  'DemographicsSelectorDialog.category.households.txt': () => `Haneler`,
  'DemographicsSelectorDialog.category.housing.txt': () => `Barındırma`,
  'DemographicsSelectorDialog.category.maritalstatus.txt': () => `Medeni Durum`,
  'DemographicsSelectorDialog.category.population.txt': () => `Nüfus`,
  'DemographicsSelectorDialog.category.usergroup.txt': () => `Kullanıcı Grubu`,
  'DemographicsSelectorDialog.category.health.txt': () => `Sağlık`,
  'DemographicsSelectorDialog.category.education.txt': () => `Eğitim`,
  'DemographicsSelectorDialog.category.business.txt': () => `İş`,
  'DemographicsSelectorDialog.category.race.txt': () => `Irk`,
  'DemographicsSelectorDialog.category.spending.txt': () => `Harcama`,
  'DemographicsSelectorDialog.category.behaviors.txt': () => `Davranışlar`,
  'DemographicsSelectorDialog.category.jobs.txt': () => `İşler`,
  'DemographicsSelectorDialog.category.poverty.txt': () => `Fakirlik`,
  'DemographicsSelectorDialog.category.tapestry.txt': () => `Dokuma`,
  'DemographicsSelectorDialog.category.atrisk.txt': () => `Risk Altında`,
  'DemographicsSelectorDialog.category.keyfacts.txt': () => `Anahtar Unsurlar`,
  'DemographicsSelectorDialog.category.supplyanddemand.txt': () => `Arz ve Talep`,
  'DemographicsSelectorDialog.category.policy.txt': () => `İlke`,
  'DemographicsSelectorDialog.category.landscape.txt': () => `Yatay`,
  'DemographicsSelectorDialog.category.crime.txt': () => `Suç`,
  'ManageColumns.title.txt': () => `Sütunları Yönet`,
  'ManageColumns.ok.txt': () => `Tamam`,
  'ManageColumns.cancel.txt': () => `İptal`,
  'ManageColumns.hiddenColumns.txt': () => `Gizli sütunlar`,
  'ManageColumns.displayedColumns.txt': () => `Görüntülenen sütunlar`,
  'SearchResultPanel.title.txt': () => `Arama Sonucu`,
  'SearchResultPanel.menu.delete.txt': () => `Arama sonucunu sil`,
  'SearchResultPanel.convert.txt': () => `Pine dönüştür`,
  'SearchResultPanel.convert.tooltip.txt': () => `Sabitlemeye dönüştür`,
  'DemographicsResultsDialog.title.txt': () => `Demografik bilgiler`,
  'DemographicsResultsDialog.cancel.txt': () => `İptal`,
  'DemographicsResultsDialog.close.txt': () => `Kapat`,
  'DemographicsResultsDialog.edit.txt': () => `Düzenle`,
  'DemographicsResultsDialog.layout.page.txt': () => `Dönen menü görünümü`,
  'DemographicsResultsDialog.layout.list.txt': () => `Tek sütun görünümü`,
  'DemographicsResultsDialog.layout.tile.txt': () => `Döşeme görünümü`,
  'DemographicsResultsDialog.noData.txt': () => `Geçerli coğrafi alanla eşleşen veri yok.`,
  'PinsAtSameLocationPanel.title.txt': () => `Aynı Konumda Pinler`,
  'PinsAtSameLocationPanel.searchResults.txt': () => `ARAMA SONUÇLARI`,
  'PinsAtSameLocationPanel.pins.txt': () => `PİNLER`,
  'PinsAtSameLocationPanel.showAll.txt': () => `Tümünü göster`,
  'PinsAtSameLocationPanel.hideAll.txt': () => `Tümünü gizle`,
  'PinsAtSameLocationPanel.deleteAll.txt': () => `Tümünü sil`,
  'PinsAtSameLocationPanel.show.txt': () => `Göster`,
  'PinsAtSameLocationPanel.hide.txt': () => `Gizle`,
  'PinsAtSameLocationPanel.delete.txt': () => `Sil`,
  'LocationPopover.pin.title.txt': () => `Konumu Pinle`,
  'LocationPopover.area.title.txt': () => `Coğrafi Alan Konumu`,
  'LocationPopover.route.title.txt': ({label}) => `Rota Konumu ${label}`,
  'LocationPopover.name.txt': () => `Ad`,
  'LocationPopover.location.txt': () => `Konum:`,
  'LocationPopover.ok.txt': () => `Konum ayarla`,
  'LocationPopover.cancel.txt': () => `Seçim modundan çık`,
  'LocationPopover.hint.txt': () => `Farklı bir konum tanımlamak için haritaya tekrar dokunun.`,
  'TreeDualSelector.source.default.txt': () => `Kullanılabilir öğeler`,
  'TreeDualSelector.target.default.txt': () => `Seçili öğeler`,
  'TreeDualSelector.filtered.length.fmt': ({label, filteredLength, totalLength}) => `${label} (${filteredLength} / ${totalLength}):`,
  'TreeDualSelector.item.length.fmt': ({label, length}) => `${label} (${length}):`,
  'TreeDualSelector.emptymessage.txt': () => `Öğe yok`,
  'TreeDualSelector.filter.placeholder.txt': () => `Filtre`,
  'TreeDualSelector.customItem.choiceIcon.tooltip.txt': () => `Özel öğe`,
  'TreeDualSelector.afterAction.add.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} öğe eklendi`,
  'TreeDualSelector.afterAction.remove.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} öğe kaldırıldı`,
  'TreeDualSelector.afterAction.addAll.txt': () => `Tüm öğeler eklendi`,
  'TreeDualSelector.afterAction.removeAll.txt': () => `Tüm öğeler kaldırıldı`,
  'TreeDualSelector.afterAction.up.txt': () => `Yukarı taşındı`,
  'TreeDualSelector.afterAction.down.txt': () => `Aşağı taşındı`,
  'TreeDualSelector.afterAction.top.txt': () => `En üste taşındı`,
  'TreeDualSelector.afterAction.bottom.txt': () => `En alta taşındı`,
  'TreeDualSelector.afterAction.undo.add.txt': () => `Ekleme eylemi geri alındı`,
  'TreeDualSelector.afterAction.undo.remove.txt': () => `Kaldırma eylemi geri alındı`,
  'TreeDualSelector.afterAction.customAdd.txt': () => `özel öğe eklendi`,
  'TreeDualSelector.customItemSelection.fmt': ({customItemSelected}) => `${customItemSelected} özel öğe seçildi`,
  'TreeDualSelector.itemSelectionWithDescription.fmt': ({itemSelected, itemDescription}) => `${itemSelected} ${itemDescription} seçildi`,
  'TreeDualSelector.itemSelection.fmt': ({itemSelected}) => `${itemSelected} seçildi`,
  'TreeDualSelector.reorderButton.up.button.aria': ({targetListLabel}) => `${targetListLabel} içinde bir satır yukarı taşı`,
  'TreeDualSelector.reorderButton.down.button.aria': ({targetListLabel}) => `${targetListLabel} içinde bir satır aşağı taşı`,
  'TreeDualSelector.reorderButton.top.button.aria': ({targetListLabel}) => `${targetListLabel} öğesinin en üstüne taşı`,
  'TreeDualSelector.reorderButton.bottom.button.aria': ({targetListLabel}) => `${targetListLabel} öğesinin en altına taşı`,
  'TreeDualSelector.moveButton.add.button.aria': ({targetListLabel}) => `${targetListLabel} listesine öğe ekle`,
  'TreeDualSelector.moveButton.addall.button.aria': ({targetListLabel}) => `${targetListLabel} hedefine tümünü ekle`,
  'TreeDualSelector.moveButton.remove.button.aria': ({targetListLabel}) => `${targetListLabel} hedefinden öğe kaldır`,
  'TreeDualSelector.moveButton.removeall.button.aria': ({targetListLabel}) => `${targetListLabel} hedefinden tümünü kaldır`,
  'TreeDualSelector.moveButton.undoadd.button.aria': ({targetListLabel}) => `${targetListLabel} için ekleme işlemini geri al`,
  'TreeDualSelector.moveButton.undoremove.button.aria': ({targetListLabel}) => `${targetListLabel} için kaldırma işlemini geri al`,
  'TreeDualSelector.searchField.aria': ({listLabel}) => `${listLabel} öğesini filtrele`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.title': () => `Kaldır`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.txt': () => `Devam ederseniz, kaldırılmak üzere seçtiğiniz özel öğelerin tümü kalıcı olarak silinir.\n\n Devam etmek istiyor musunuz?`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.title': () => `Tüm Öğeleri Kaldır`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.txt': () => `Devam ederseniz bu listedeki özel öğeler kalıcı olarak silinir.\n\n Devam etmek istiyor musunuz?`,
  'LinkNavigator.backButton.label': () => `Geri`,
  'LinkNavigator.rootOrReportLinkBreadcrumb.label': ({reportLabel, sectionLabel}) => `${reportLabel}: ${sectionLabel}`,
  'LinkNavigator.incomingFilters.title': () => `Gelen Filtreleri`,
  'LinkNavigator.reportLevel.label': () => `Rapor düzeyi`,
  'LinkNavigator.sectionLevel.label': () => `Sayfa düzeyi`,
  'ReportSectionZeroState.heading.label': () => `Rapor Tasarla`,
  'ReportSectionZeroState.description.label': () => `Nesneleri veya veri öğelerini sayfaya sürükleyin ya da aşağıdan bir seçenek belirleyin.`,
  'ReportSectionZeroState.hideAutoChartButton.description.label': () => `Nesneleri veya veri öğelerini sayfaya sürükleyin ya da bir sayfa şablonundan başlayın.`,
  'ReportSectionZeroState.autoChartButton.label': () => `Nesne oluştur`,
  'ReportSectionZeroState.selectTemplateButton.label': () => `Tarih belirleyin`,
  'ReportSectionZeroState.exploreSuggestions.label': () => `Önerileri keşfet`,
  'PromptContainerTooltip.noSelections.txt': () => `Seçim yok`,
  'PromptContainerTooltip.selectedValues.txt': () => `Seçilen Değerler`,
}
export default localizers;
